import * as React from 'react'
import APageRow from '../../components/atoms/APageRow'
import AText from '../../components/atoms/AText'
import MForm from '../../components/molecules/MForm'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import AField from '../../components/atoms/AField'
import AButton from '../../components/atoms/AButton'
import AButtonGroup from '../../components/atoms/AButtonGroup'
import { IApiConsumerEntity } from '../../data/actions.interface'
import { getSettings, updateSettings } from './settings.actions'
import { IPowerbiSettingsDto } from './settings.dto'

interface IPowerbiSettings extends IApiConsumer {
    settings: IApiConsumerEntity<IPowerbiSettingsDto>
}

interface IPowerbiSettingsState {
    saved: boolean
}

class PowerbiSettings extends React.Component<IPowerbiSettings, IPowerbiSettingsState> {
    readonly state: IPowerbiSettingsState = { saved: false }

    handleSubmit = (values: IPowerbiSettingsDto) => {
        this.setState({ saved: false })

        return this.props.dispatch(updateSettings(values)).then(res => {
            this.setState({ saved: true })

            return res
        })
    }

    render() {
        const { settings } = this.props

        if (settings.status !== 'success') {
            return (
                <APageRow>
                    <AText>Loading settings...</AText>
                </APageRow>
            )
        }

        return (
            <APageRow>
                <MForm
                    key="powerbi-settings"
                    initialValues={settings.response}
                    onSubmit={this.handleSubmit}
                >
                    <AField bound name="POWERBI_GROUP_ID" type="text" placeholder="Workspace / Group ID" />
                    <AField bound name="POWERBI_DATASET_ID" type="text" placeholder="Dataset ID" />
                    <AField bound name="POWERBI_REPORT_ID" type="text" placeholder="Report ID" />
                    <AField bound name="POWERBI_EMBED_URL" type="text" placeholder="Embed URL" />
                    <AButtonGroup>
                        <AButton outline color="error" type="submit">
                            Save
                        </AButton>
                    </AButtonGroup>
                </MForm>
                {this.state.saved && <AText>Settings saved.</AText>}
            </APageRow>
        )
    }
}

export default apiConsumer({
    settings: () => getSettings(),
})(PowerbiSettings)
